export const formatterDate = (date: string): string => {
    const newDate = new Date(date)
    return newDate.toLocaleDateString("it-IT")
}
